export interface QuickEntry {
  label: string;
  icon: string;
  to: string;
  desc: string;
}

export const quickEntries: QuickEntry[] = [
  {
    label: "泰国腐剧",
    icon: "ri-movie-2-line",
    to: "/category/泰国腐剧",
    desc: "精选高口碑泰国双男主剧集，一次看个够",
  },
  {
    label: "双男主影视",
    icon: "ri-user-heart-line",
    to: "/tags/双男主",
    desc: "聚焦双男主关系与情感线的优质作品合集",
  },
  {
    label: "最新更新",
    icon: "ri-time-line",
    to: "/category/最新更新",
    desc: "按更新时间排序，追更新剧不错过任何一集",
  },
  {
    label: "热门推荐",
    icon: "ri-fire-line",
    to: "/category/热门推荐",
    desc: "根据热度与人气整理的当下最火剧单",
  },
];

export interface GenreTag {
  name: string;
  icon: string;
  desc: string;
}

export const genreTags: GenreTag[] = [
  { name: "双男主", icon: "ri-user-heart-line", desc: "以两位男主的情感关系为核心的作品" },
  { name: "青春校园", icon: "ri-graduation-cap-line", desc: "发生在校园里的青涩恋爱故事" },
  { name: "甜宠", icon: "ri-heart-3-line", desc: "轻松甜蜜、让人嘴角上扬的治愈系" },
  { name: "虐恋", icon: "ri-emotion-sad-line", desc: "情感浓烈、起伏跌宕的虐心之作" },
  { name: "悬疑", icon: "ri-search-eye-line", desc: "融合悬念与反转的紧张剧情" },
  { name: "黑帮", icon: "ri-mickey-line", desc: "地下世界里的危险与深情" },
  { name: "治愈", icon: "ri-sun-line", desc: "温暖明亮、抚慰人心的慢节奏作品" },
  { name: "暗恋", icon: "ri-eye-off-line", desc: "藏在心底、小心翼翼的单向心动" },
  { name: "豪门", icon: "ri-building-2-line", desc: "财阀家族背景下的命运纠葛" },
  { name: "都市", icon: "ri-building-4-line", desc: "发生在城市里的成年爱情故事" },
  { name: "军旅", icon: "ri-shield-star-line", desc: "守卫一方土地与彼此信念的故事" },
  { name: "深夜食堂", icon: "ri-restaurant-2-line", desc: "用食物与深夜时光治愈人心" },
];

export interface CategoryMeta {
  name: string;
  desc: string;
}

export const categoryMetas: CategoryMeta[] = [
  { name: "泰国腐剧", desc: "聚焦泰国出品的双男主题材剧集，涵盖甜宠、虐恋、悬疑等多元风格，均为口碑与人气兼具的精选作品。" },
  { name: "双男主影视", desc: "以两位男主角的情感关系为主线，强调细腻的情感刻画与人物成长，是双男主题材爱好者不可错过的合集。" },
  { name: "最新更新", desc: "按更新时间倒序排列的剧集清单，帮助你第一时间掌握最新的追更动态，不错过任何一部新上线的作品。" },
  { name: "热门推荐", desc: "综合热度、评分与观众讨论度整理出的当红剧单，如果你刚接触这类题材，从这里开始准没错。" },
];